/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SecurityAuthenticationModalLongDescriptionAliases {
  LAYOUT_LONG_DESCRIPTION = 'layout-long-description',
  TEXT_EDITOR_LONG_DESCRIPTION_MODAL_LONG_DESCRIPTION = 'text-editor-long-description-modal-long-description',
}
export { SecurityAuthenticationModalLongDescriptionAliases };
